import { FORM_CONFIGS } from "./form_config_enum";
import { REACT_QUERY_KEYS } from "./react_query_key_enum";
import { fetchCrmAvailableSites } from "../scripts/api_v2/crm_client";
import { fetchPartnerCompanies } from "../scripts/api_v2/partner_company_client";
import { FINAL_VERIFICATION_ACTIONS } from "../pages/elion_site/tabs/commissioning_tab/components/enum/final_verification_actions";

export const FORM_ACTIONS = Object.freeze({
  COMMISSIONING_DENY_REASON: {
    action: FINAL_VERIFICATION_ACTIONS.RESET_CONTROL,
    formConfig: FORM_CONFIGS.COMMISSIONING_DENY_REASON,
    parseHeader: (row) => "Enter commissioning deny reason",
  },
  COMMISSIONING_COMMENTS: {
    action: FINAL_VERIFICATION_ACTIONS.ADD_COMMENTS,
    formConfig: FORM_CONFIGS.COMMISSIONING_COMMENTS,
    parseHeader: (row) => "Add commissioning comments",
  },
  DRAFT_INSTALLATION: {
    action: "draft_installation",
    formConfig: FORM_CONFIGS.DRAFT_INSTALLATION,
    parseHeader: (row) => "Create new site",
  },
  NEW_INSTALLATION_FOR_CRM: {
    action: "new_installation_for_crm",
    formConfig: FORM_CONFIGS.NEW_INSTALLATION,
    parseHeader: (row) => "Create new installation and link to contract: " + row["elion_name"],
  },
  DRAFT_INSTALLATION_WITH_PARTNER_PRIVILEGE: {
    action: "draft_installation_with_partner_privilege",
    formConfig: FORM_CONFIGS.DRAFT_INSTALLATION_WITH_PARTNER_PRIVILEGE,
    parseHeader: (row) => "Create new installation",
    queryKey: REACT_QUERY_KEYS.AVAILABLE_PARTNER_COMPANIES,
    queryFn: (backend) => fetchPartnerCompanies(backend),
    fnDataAccessKey: "company_id",
    fnDataLabelKey: "company_name",
    searchPlaceholder: "Find partner company",
  },
  SEARCH_SITE_FOR_CRM: {
    action: "search_site_for_crm",
    formConfig: FORM_CONFIGS.LINK_TO_EXISTING_INSTALLATION,
    parseHeader: (row) => "Link installation to contract: " + row["elion_name"],
    queryKey: REACT_QUERY_KEYS.CRM_AVAILABLE_SITES,
    queryFn: (backend) => fetchCrmAvailableSites(backend),
    fnDataAccessKey: "site_id",
    fnDataLabelKey: "site_name",
    searchPlaceholder: "Find site",
  },
  REPLACE_SMARTBOX: {
    action: "replace_smartbox",
    formConfig: FORM_CONFIGS.REPLACE_SMARTBOX,
    parseHeader: (row) => "Replace smartbox of site: " + row["site_name"],
  },
  RENAME_SITE: {
    action: "rename_site",
    formConfig: FORM_CONFIGS.RENAME_SITE,
    parseHeader: (row) => "Rename site: " + row["site_name"],
  },
  ADD_OWNERS: {
    action: "add_site_owners",
    formConfig: {},
    parseHeader: (row) => "Add owners to site: " + row["site_name"],
    queryKey: REACT_QUERY_KEYS.AVAILABLE_PARTNER_COMPANIES,
    queryFn: (backend) => fetchPartnerCompanies(backend),
    fnDataAccessKey: "company_id",
    fnDataLabelKey: "company_name",
    searchPlaceholder: "Find partner company",
  },
});
